import React from 'react';
import { Box } from "@mui/material";

function Footer(props) {
    return (
        <footer className="footer">
            <div className="footer-content">
                <ul className="footer-links">
                    <li><a target="_blank" rel="noopener noreferrer" href="https://docs.premierit.com/policies/web/privacy-notice.html">Privacy</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://docs.premierit.com/policies/web/accessibility-statement.html">Accessibility</a></li>
                    <li><a target="_blank" rel="noopener noreferrer" href="https://docs.premierit.com/policies/web/terms-of-use.html">Terms of use</a></li>
                </ul>
                <div className="copyright">
                    Copyright &copy; 2023 <a href="https://www.premierit.com" target="_blank" rel="noopener noreferrer">Premier IT</a>
                </div>
            </div>
            <Box className="bg-left"/>
        </footer>
    );
}

export default Footer;
